import {
  defaultShouldDehydrateQuery,
  MutationCache,
  QueryClient,
} from '@tanstack/react-query'
import { toast } from 'sonner'
import SuperJSON from 'superjson'

import { isAuthError } from '@/lib/query-client/is-auth-error'

export const makeQueryClient = (onAuthError?: () => void) => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        // With SSR, we usually want to set some default staleTime
        // above 0 to avoid refetching immediately on the client
        staleTime: 60 * 1000,
        // Don't retry on 404/NOT_FOUND errors (provisional chats)
        retry: (failureCount, error: any) => {
          // Don't retry if it's a NOT_FOUND error
          if (error?.data?.code === 'NOT_FOUND') return false
          // Don't retry on 404 status
          if (error?.status === 404) return false
          // Retry up to 2 times for other errors
          return failureCount < 2
        },
      },
      dehydrate: {
        serializeData: SuperJSON.serialize,
        shouldDehydrateQuery: (query) =>
          defaultShouldDehydrateQuery(query) ||
          query.state.status === 'pending',
      },
      hydrate: {
        deserializeData: SuperJSON.deserialize,
      },
    },
    mutationCache: new MutationCache({
      onError: (error) => {
        if (!isAuthError(error)) return
        toast.error('Your session has expired. Please sign in again.')
        onAuthError?.()
      },
    }),
  })
  return queryClient
}
